var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlockOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 0.5C12.25 0.523438 13.75 2.04688 13.75 3.92188V5.1875C13.75 5.51562 13.4922 5.75 13.1875 5.75C12.8594 5.75 12.625 5.51562 12.625 5.1875V3.875C12.625 2.63281 11.5938 1.625 10.3516 1.625C9.10938 1.64844 8.125 2.67969 8.125 3.92188V5H9.625C10.2344 5 10.75 5.51562 10.75 6.125V11.375C10.75 12.0078 10.2344 12.5 9.625 12.5H1.375C0.742188 12.5 0.25 12.0078 0.25 11.375V6.125C0.25 5.51562 0.742188 5 1.375 5H7V3.875C7 2.02344 8.5 0.5 10.375 0.5ZM9.625 6.125H1.375V11.375H9.625V6.125ZM5.52344 10.1562C5.14844 10.1562 4.86719 9.875 4.86719 9.5V8C4.86719 7.64844 5.14844 7.34375 5.52344 7.34375C5.875 7.34375 6.17969 7.64844 6.17969 8V9.5C6.17969 9.875 5.875 10.1562 5.52344 10.1562Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockOpened);
export default __webpack_public_path__ + "static/media/padlock-opened.33a0c915.svg";
export { ForwardRef as ReactComponent };